import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getStakes} from '../api';
import {QUERY__STAKES} from '../queryKeys';
import {Stake} from '../types';

export const useGetStakes = <SelectedData = GetListOutput<Stake>>(
  params: Parameters<typeof getStakes>[0],
  options?: QueryOptionsForList<Stake, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__STAKES, params],
    queryFn: () => getStakes(params),
    ...options,
  });
